module.exports = __webpack_public_path__ + "static/media/Group 11299.621de0a9.svg";